<template>
    <div>
      <v-card class='mx-2' outlined>
        <v-card-title>
          License History
        </v-card-title>
        <v-data-table 
            v-model="selected" 
            :headers="headers" 
            :items="licenses" 
            :items-per-page='parseInt("-1")'
            no-data-text="No Licenses">
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class='mr-2' v-clipboard:copy="(item.jwt)" @click="copyJwtTooltipTextChange()"> fa-copy  </v-icon>
                </template>
                <span>{{copyJwtTooltipText}}</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class='mr-2' @click="gwLink(item)"> fa-hdd  </v-icon>
                </template>
                <span>Open gateway page in QxControl</span>
              </v-tooltip>
            </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>

import env from '../../server.config'

export default {
  name: "LicenseHistory",
  props: {
    app: Object,
    encodedWgip: String,
  },
  data: () => ({
    selected: [],
    licenses: [],
    wgip: '',
    copyJwtTooltipText: 'Copy license JWT',
  }),

  created() {
    console.log('Licenses created')
    //this.initialize();
  },

  mounted() {
    console.log('Licenses mounted');
    this.wgip = decodeURIComponent(this.encodedWgip);
    setTimeout(() => {
      this.initialize();
    }, 100);
  },

  computed: {
    headers() {
      return [
        {
          text: 'System S/N',
          align: 'center',
          value: 'serNum'
        },
        {
          text: 'WG Address',
          align: 'center',
          value: 'wgip'
        },
        {
          text: 'Version',
          align: 'left',
          value: 'version'
        },
        {
          text: 'Cust Id',
          align: 'left',
          value: 'customerId'
        },
        {
          text: 'Dist Id',
          align: 'left',
          value: 'distId'
        },
        {
          text: 'Type',
          align: 'left',
          value: 'type',
        },
        {
          text: 'Resources',
          align: 'left',
          value: 'resourceCount'
        },
        {
          text: 'Cameras',
          align: 'left',
          value: 'cameraCount'
        },
        {
          text: 'Max Resources',
          align: 'left',
          value: 'maxResources'
        },
        {
          text: 'Max Cameras',
          align: 'left',
          value: 'maxCameras'
        },
        {
          text: 'Expires',
          align: 'left',
          value: 'exp'
        },
        {
          text: 'Date Created',
          align: 'left',
          value: 'createdDate'
        },
        {
          text: 'Date Modified',
          align: 'left',
          value: 'modifiedDate'
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'action',
          sortable: false
        }
      ]
    }, 
  },

  methods: {
    initialize() {
      this.getLicenseHistory(this.wgip);
    },

    copyJwtTooltipTextChange() {
      this.copyJwtTooltipText = "Copied";
      setTimeout( () => {
        this.copyJwtTooltipText = "Copy license JWT"
      }, 500)
    },

    getLicenseHistory(wgip) {
      this.app.restApi({
          method: 'get',
          url: `/API/public/license/dummy?wgip=${wgip}&showHistory=true`,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          this.licenses = Object.values(response.data);
          this.licenses.forEach(element => {
            if (element.exp) element.exp = new Date(element.exp * 1000).toISOString().substring(0,10);  // TODO - Timezone offset
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    gwLink(item) {
      let gwUrl = '';
      this.app.restApi({
          method: 'get',
          url: `API/public/system/${item.serNum}/gw`,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          const gwid = Object.values(response.data);
          gwUrl = env.appBaseUrl + `/#/qx/gateways/${gwid}`;
          window.open(gwUrl, '_blank');
        })
        .catch(function (error) {
          if (error.response.status === 404) { // on-prem system?
            const dotIndex = env.appBaseUrl.indexOf(".");
            const appBaseUrl = env.appBaseUrl.substring(dotIndex);
            const splitWgIp = item.wgip.split('.');
            if (splitWgIp.length == 4) {
              let hostbase = 'qx';
              for (let ii=1; ii<=3; ii++) {
                hostbase += ('00' + Number(splitWgIp[ii]).toString(16)).slice(-2);
              }
              gwUrl = `https://${hostbase}-pub${appBaseUrl}`;
              window.open(gwUrl, '_blank');
            }
          } else {
            console.log("Licenses::gwLink() error: ", error);
          }
        });
    },
  }
}
</script>